'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BetslipInteracter = function () {
    function BetslipInteracter() {
        (0, _classCallCheck3.default)(this, BetslipInteracter);

        this.onBookmakerChanged = this.onBookmakerChanged.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.setBetslipBookmaker = this.setBetslipBookmaker.bind(this);
        this.init = this.init.bind(this);
        this.decimalOdds = false;
    }

    (0, _createClass3.default)(BetslipInteracter, [{
        key: 'init',
        value: function init(feedName) {
            var deferred = _jquery2.default.Deferred();
            this.resolvePromise = deferred.resolve;
            var customizeSettingsCookie = _jquery2.default.cookie('customizeSettings');
            if (customizeSettingsCookie) {
                var customizeSettings = JSON.parse(customizeSettingsCookie);
                this.decimalOdds = customizeSettings.decimalOdds;
            }
            this.bindEvents();
            if (feedName) {
                this.feedName = feedName;
                this.setBetslipBookmaker(feedName);
            } else {
                this.requestSelectedBookmaker();
            }
            return deferred.promise();
        }
    }, {
        key: 'onBookmakerChanged',
        value: function onBookmakerChanged(_ref) {
            var bookmaker = _ref.detail.bookmaker;

            (0, _jquery2.default)(document).trigger('bookieChanged.BOOKMAKER', bookmaker);
            this.resolveBookmaker(bookmaker);
        }
    }, {
        key: 'resolveBookmaker',
        value: function resolveBookmaker(bookmaker) {
            if (this.resolvePromise) {
                this.resolvePromise(bookmaker);
                this.resolvePromise = null;
                delete this.resolvePromise;
            }
        }
    }, {
        key: 'onBetslipInitialized',
        value: function onBetslipInitialized() {
            if (this.feedName) {
                this.setBetslipBookmaker(this.feedName);
                this.resolveBookmaker(this.feedName);
            } else {
                this.requestSelectedBookmaker();
            }
        }
    }, {
        key: 'requestSelectedBookmaker',
        value: function requestSelectedBookmaker() {
            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.GET');
            document.dispatchEvent(betslipEvent);
        }
    }, {
        key: 'setBetslipBookmaker',
        value: function setBetslipBookmaker(bookmaker) {
            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                detail: { bookmaker: bookmaker }
            });
            document.dispatchEvent(betslipEvent);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            document.addEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
            document.addEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
            document.addEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            document.removeEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
            document.removeEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
            document.removeEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        }
    }]);
    return BetslipInteracter;
}();

exports.default = BetslipInteracter;


//////////////////
// WEBPACK FOOTER
// ./public/js/betslipInteracter.js
// module id = 1479
// module chunks = 0